import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { DisassociateBillingMethodRequestPayload } from '@/models/ps-management/multi-methods.model';

export default class DisassociateBillingMethodRequest extends ApiResourceMethod<{}> {
  public perform(payload: DisassociateBillingMethodRequestPayload): Promise<{}> {
    return this.performer.requestWithMapper(
      { url: `${payload.multiMethodId}/billingPaymentMethod/${payload.billingPaymentMethodId}` },
      (payload: BaseResponse<{}>) => {
        return payload.data;
      },
    );
  }
}
